import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, fas } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./ViewOffCanvance.css";
import { Context } from "../../../utils/context";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import "react-phone-input-2/lib/bootstrap.css";
import Select from "react-select";
import { CancelButton, SaveButton } from "../../common/Button";
import ModalSave from "../../common/ModelSave";
import ImagePreviewDialog from "../../common/ImagePreview/ImagePreview";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(fas);

const ViewOffCanvance = (props) => {
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [locationTab, setLocationTab] = useState("");

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const dataToSend = new FormData();
      dataToSend.append("stage", data?.stage?.value);
      dataToSend.append("email", data?.email);
      const response = await postData(`/admin/expert/${props.id}`, dataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [data, setData] = useState();
  const getSellerData = async () => {
    const res = await getData(`/admin/expert/${props.id}`);
    setData(res.data);
  };

  useEffect(() => {
    getSellerData();
  }, [props.id]);

  useEffect(() => {
    if (data?.Expert_Areas?.length > 0 && !locationTab) {
      setLocationTab(data.Expert_Areas[0]?.Location_Type?.name);
    }
  }, [data]);

  const dialogRef = useRef();
  const [selectedImage, setSelectedImage] = useState("");
  const openImage = (image) => {
    setSelectedImage(image);
    dialogRef.current?.showModal();
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%", height: "auto" }}
        placement={"end"}
        onHide={props.handleClose}
        className="offcan"
      >
        <div className="tabss-main">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <div className="shadow-lg p-3 mb-5  rounded">
              <Card.Body>
                <Card.Title>
                  <h3>Expert Details</h3>
                </Card.Title>

                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Personal Details" value="1" />
                        <Tab label="Vehicle Details" value="2" />
                        {/* <Tab label="Cirtification Details" value="3" /> */}
                        <Tab label="Expert Areas" value="4" />
                        <Tab label="Bank Details" value="5" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <div>
                        <div>
                          <h3>Personal Details</h3>
                        </div>

                        <div>
                          <Row>
                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label> Name</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.name}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            {/* <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Roll in store</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.role_in_store}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col> */}

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Contact Number</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.contact_no}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            {/* <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Email</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.email}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col> */}

                            {/* <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Designation</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.role_in_store}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col> */}
                            <Col lg={4} className=""></Col>
                            <Col lg={4} className="">
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Pan Card Front</Form.Label>

                                  <div className="image-boxes-main">
                                    <img
                                      className="image-boxes"
                                      src={
                                        IMG_URL + data?.Kyc_Document?.pan_front
                                      }
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Kyc_Document?.pan_front,
                                        )
                                      }
                                    />

                                    <FontAwesomeIcon
                                      icon={faEye}
                                      className="view_eye"
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Kyc_Document?.pan_front,
                                        )
                                      }
                                    />
                                  </div>
                                </Row>
                              </div>
                            </Col>
                            <Col lg={4} className="">
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Pan Card Back</Form.Label>

                                  <div className="image-boxes-main">
                                    <img
                                      className="image-boxes"
                                      src={
                                        IMG_URL + data?.Kyc_Document?.pan_back
                                      }
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Kyc_Document?.pan_back,
                                        )
                                      }
                                    />{" "}
                                    <FontAwesomeIcon
                                      icon={faEye}
                                      className="view_eye"
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Kyc_Document?.pan_back,
                                        )
                                      }
                                    />
                                  </div>
                                </Row>
                              </div>
                            </Col>
                            <Col lg={4} className=""></Col>
                            <Col lg={4} className="">
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Aadhar Card Front</Form.Label>

                                  <div className="image-boxes-main">
                                    <img
                                      className="image-boxes"
                                      src={
                                        IMG_URL +
                                        data?.Kyc_Document?.aadhar_front
                                      }
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Kyc_Document?.aadhar_front,
                                        )
                                      }
                                    />{" "}
                                    <FontAwesomeIcon
                                      icon={faEye}
                                      className="view_eye"
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Kyc_Document?.aadhar_front,
                                        )
                                      }
                                    />
                                  </div>
                                </Row>
                              </div>
                            </Col>
                            <Col lg={4} className="">
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Aadhar Card Back</Form.Label>

                                  <div className="image-boxes-main">
                                    <img
                                      className="image-boxes"
                                      src={
                                        IMG_URL +
                                        data?.Kyc_Document?.aadhar_back
                                      }
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Kyc_Document?.aadhar_back,
                                        )
                                      }
                                    />{" "}
                                    <FontAwesomeIcon
                                      icon={faEye}
                                      className="view_eye"
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Kyc_Document?.aadhar_back,
                                        )
                                      }
                                    />
                                  </div>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                      <div>
                        <div>
                          <h3>Vehicle Details</h3>
                        </div>

                        <div>
                          <Row>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Vehicle Number</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.Expert_Detail?.vehicle_number
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Vehicle Name</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.Expert_Detail?.Vehicle?.name
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>City Name</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.Expert_Detail?.City?.name}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col lg={4} className="">
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>RC Book(Front)</Form.Label>

                                  <div className="image-boxes-main">
                                    <img
                                      className="image-boxes"
                                      src={
                                        IMG_URL +
                                        data?.Expert_Detail?.rc_book_front
                                      }
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Expert_Detail?.rc_book_front,
                                        )
                                      }
                                    />{" "}
                                    <FontAwesomeIcon
                                      icon={faEye}
                                      className="view_eye"
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Expert_Detail?.rc_book_front,
                                        )
                                      }
                                    />
                                  </div>
                                </Row>
                              </div>
                            </Col>
                            <Col lg={4} className="">
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>RC Book(Back)</Form.Label>

                                  <div className="image-boxes-main">
                                    <img
                                      className="image-boxes"
                                      src={
                                        IMG_URL +
                                        data?.Expert_Detail?.rc_book_back
                                      }
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Expert_Detail?.rc_book_back,
                                        )
                                      }
                                    />{" "}
                                    <FontAwesomeIcon
                                      icon={faEye}
                                      className="view_eye"
                                      onClick={() =>
                                        openImage(
                                          IMG_URL +
                                            data?.Expert_Detail?.rc_book_back,
                                        )
                                      }
                                    />
                                  </div>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </TabPanel>

                    {/* <TabPanel value="4">
                      <div>
                        <h3>Expert Areas</h3>

                        <Row>
                          <Col lg={12}>
                            <div className="main-form-section mt-4">
                              <div className="table-responsive">
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Location Type</th>
                                      <th>Area</th>
                                      <th>Country</th>
                                      <th>State</th>
                                      <th>City</th>
                                      <th>Pincode</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {data?.Expert_Areas?.length > 0 ? (
                                      data?.Expert_Areas?.map((item, index) => (
                                        <tr key={index}>
                                          <td>
                                            {item?.Location_Type?.name || "-"}
                                          </td>

                                          <td>{item?.Area?.name || "-"}</td>

                                          <td>
                                            {item?.Area?.Country?.name || "-"}
                                          </td>

                                          <td>
                                            {item?.Area?.State?.name || "-"}
                                          </td>

                                          <td>
                                            {item?.Area?.City?.name || "-"}
                                          </td>

                                          <td>
                                            {item?.Area?.Pincode?.name || "-"}
                                          </td>

                                          <td>
                                            {item?.status
                                              ? "Active"
                                              : "Inactive"}
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="7" className="text-center">
                                          No Expert Areas Available
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </TabPanel> */}

                    <TabPanel value="4">
                      <div>
                        <h3>Expert Areas</h3>

                        {/* Tabs */}
                        <div className="d-flex gap-2 mb-3">
                          {[
                            ...new Set(
                              data?.Expert_Areas?.map(
                                (i) => i?.Location_Type?.name,
                              ),
                            ),
                          ].map((type, idx) => (
                            <button
                              key={idx}
                              onClick={() => setLocationTab(type)}
                              className="btn"
                              style={{
                                backgroundColor:
                                  locationTab === type
                                    ? "#884A29"
                                    : "transparent",
                                color:
                                  locationTab === type ? "#fff" : "#884A29",
                                border: `1px solid #884A29`,
                                borderRadius: "6px",
                                padding: "6px 12px",
                                fontWeight: 500,
                              }}
                            >
                              {type}
                            </button>
                          ))}
                        </div>

                        {/* Table */}
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Area</th>
                                <th>Country</th>
                                <th>State</th>
                                <th>City</th>
                                <th>Pincode</th>
                                <th>Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.Expert_Areas?.filter(
                                (item) =>
                                  item?.Location_Type?.name === locationTab,
                              )?.length > 0 ? (
                                data.Expert_Areas.filter(
                                  (item) =>
                                    item?.Location_Type?.name === locationTab,
                                ).map((item, index) => (
                                  <tr key={index}>
                                    <td>{item?.Area?.name || "-"}</td>
                                    <td>{item?.Area?.Country?.name || "-"}</td>
                                    <td>{item?.Area?.State?.name || "-"}</td>
                                    <td>{item?.Area?.City?.name || "-"}</td>
                                    <td>{item?.Area?.Pincode?.name || "-"}</td>
                                    <td>
                                      {item?.status ? "Active" : "Inactive"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    No Data Available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </TabPanel>

                    <TabPanel value="5">
                      <div>
                        <div>
                          <h3>Bank Details</h3>
                        </div>
                        <div>
                          <Row>
                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Account Holder Name</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.Bank_Detail?.account_holder_name
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Bank Account Number</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.Bank_Detail?.account_no}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>IFSC Code</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.Bank_Detail?.ifsc_code}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
              </Card.Body>
            </div>
          </Offcanvas.Body>
          {/* <Col md={4}>
            <div className="main-form-section mt-3">
              <Form.Group>
                <Form.Label>Take an action</Form.Label>
                <InputGroup>
                  <Controller
                    name="stage" // name of the field
                    control={control}
                    rules={{ required: "Take an Action" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.stage ? "red" : baseStyles.borderColor,
                          }),
                        }}
                        options={[
                          { value: "Approved", name: "option", label: "Approve" },
                          { value: "Rejected", name: "option", label: "Reject" },
                        ]}
                      />
                    )}
                  />
                </InputGroup>
                {errors.stage && <p style={{ color: "red" }}>{errors.stage.message}</p>}
              </Form.Group>
            </div>
          </Col>

          <Row className="mt-5 pb-3">
            <div className="d-flex justify-content-center">

              <CancelButton
                name={"Back"}
                handleClose={props.handleClose}
              />


              <SaveButton
                name={"save"}
                handleSubmit={handleSubmit(onSubmit)}
              />
            </div>
          </Row> */}
        </div>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <ImagePreviewDialog ref={dialogRef} image={selectedImage} />
    </>
  );
};

export default ViewOffCanvance;
